import React from 'react';
import { Button } from 'bloomer';
import styled from 'styled-components';
import { colors } from '../../styles/colors';

const StyledButton = styled(Button)`
  color: ${colors.primaryText};
  background-color: ${colors.primarybakground};
  font-weight: bold;
  transition: background-color 0.2s;

  &:hover,
  &:active,
  &:focus {
    color: ${colors.primaryText};
    border-color: transparent;
  }
`;

export type ButtonProps = {
  loading?: boolean;
  onClick: () => void;
};

export default class PrimaryButton extends React.PureComponent<ButtonProps> {
  render() {
    return this.props.loading
      ? <StyledButton isLoading>{this.props.children}</StyledButton>
      : <StyledButton onClick={this.props.onClick}>{this.props.children}</StyledButton>;
  }
}
